<template>
  <div class="bars">
    <van-nav-bar
      title=""
      left-text="返回"
      left-arrow
      :fixed="true"
      @click-left="onClickLeft"
    />
    <!-- <div class="top">
      <div class="title">· 品牌分类 ·</div>
    </div> -->
    <!-- <div class="nav">
      <div
        class="one"
        @click="golist(v.id)"
        v-for="v in brand"
        :key="v.id"
      >
        <div
          class="xian"
          v-show="pids==v.id"
        ></div>
        <img
          :src="v.brand_logo"
          alt="图片"
        >
      </div>

    </div> -->
    <div class="product">
      <!-- <div class="wai">
        <div class="side">
          <van-sidebar v-model="activeKey">
            <van-sidebar-item
              title="推荐产品"
              @click='side("推荐产品",-1)'
            />
            <van-sidebar-item
              v-for="(v,i) in names"
              :key="v.id"
              :title="v.name"
              @click='side(v.name,v.id,i)'
            />
          </van-sidebar>
        </div>
      </div> -->

      <div class="content">
        <div class="title">{{title}}</div>
        <div
          class="no"
          v-show="goods.length==0"
        >暂无商品~</div>
        <ul class="clearfix">
          <li
            v-for="v in goods "
            :key="v.id"
            @click="goproud(v.id,v.son_store_id)"
          >
          <div class="zu">
          <div class="pb">
            <img src="../../assets/s11/11.png" alt="">
          </div>
            <img
              :src="v.thumb"
              alt=""
            >
            <p
              v-show="jf"
              class="price"
            ><span>特惠价格</span>{{login==0?"价格登录可见":"￥"+v.min_price}}</p>
            <p
              v-show="!jf"
              class="price"
            ></p>
            <p class="name">{{v.name}}</p>
            <p class="name shop"> {{(v.store_name)?v.store_name:''}}</p>
            </div>
          </li>

        </ul>
       <div
      class="but"
      @click="open"
      v-show="[21,395].indexOf(classid)!=-1  || [21,395].indexOf($store.state.spid)!=-1 "
    >
    <img src="../../assets/jxs.png" alt="">
      <!-- <van-button
        type="danger"
        size="large"
      >分销商入口></van-button> -->
    </div>
      </div>
    </div>
    <!-- <div
      class="but"
      @click="open"
    >
      <van-button
        type="danger"
        size="large"
      >超级会员更省心，立即开通></van-button>
    </div> -->
     
  </div>
</template>
<script>
import Vue from 'vue'
import {
  NavBar,
  GoodsAction, GoodsActionIcon, GoodsActionButton,
  Sidebar, SidebarItem,
  ImagePreview,
  Toast,
  Button,Popup
} from 'vant'

Vue.use(NavBar)
  .use(SidebarItem)
  .use(Sidebar)
  .use(ImagePreview).use(GoodsAction)
  .use(GoodsActionButton)
  .use(GoodsActionIcon).use(Toast).use(Button).use(Popup)
export default {


  created () {

    if (JSON.parse(localStorage.getItem('user')).id != 0) {
      this.login = 1
    } else {
    }

    if (this.$store.state.pid) {
      this.ids = this.$store.state.pid
    } else {
      this.$store.state.pid = this.$route.query.id
      this.ids = this.$route.query.id
    }
    if ([16, 17, 23,30,27].indexOf(this.$store.state.shopid) == -1) {
      this.jf = true
    } else {
      this.jf = false
    }
   
    this.axios.get('doubleEleven', { params: { store_id: this.$store.state.shopid, class_id: this.ids ,class_name:this.$route.query.name} }).then(res => {
      // if (res.data.code == 200) {
      //   this.navs = res.data.info
      //     
      this.goods = res.data.data.recommend
      
      res.data.data.threeClass.forEach(v => {
        if (v.id == 196) {

        } else {
          this.names.push(v)
        }
      })
      this.brand = res.data.data.brand
     
    }).catch(ref => { })
    
    
    // if (this.$route.params.status) {
    //   this.side()
    //   console.log(1)
    // }
  },
  data () {
    return {
      jf: true,
      pids: "",
      ids: '',
      classid: '',
      login: 0,
      title: '双十一特惠精选',
      activeKey: 0,
      names: [],
      goods: [],
      brand: [],
      show:false,
      value:'',

    }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    side (v, id,i) {
      
      document.documentElement.scrollTop=0

      this.title = v
      this.$store.state.soncname=v
      this.classid = id
      this.$store.state.spid=id
      this.$store.state.spid1=i
      if (id == -1) {
        this.axios.get('doubleEleven', { params: { store_id: this.$store.state.shopid, class_id: this.ids, class_name:this.$route.query.name} }).then(res => {
          this.goods = res.data.data.recommend
        }).catch(ref => { })
      } else {
        this.axios.get('doubleElevenByCateBrand', { params: { store_id: this.$store.state.shopid, class_id: id, brand_id: this.pids, class_name:this.$store.state.soncname} }).then(res => {
          // console.log(res)
          this.goods = res.data.data
          
        }).catch(ref => { })
      }
    },
    goproud (id,s) {
      // console.log(s)
    
      this.$router.push({ name: 'products11', query: { id } })

      

    
      
      return
    },
    golist (id) {
      // console.log(this.classid)
      if (this.pids == id) {
        this.pids = 0
      } else {
        this.pids = id
      }
      if (this.classid == '' || this.classid == -1) {
        this.axios.get('doubleEleven', { params: { store_id: this.$store.state.shopid, class_id: this.ids,class_name:this.$route.query.name } }).then(res => {
          this.goods = []
          res.data.data.recommend.forEach(v => {
            if (v.brand == id) {
              this.goods.push(v)
            }
          });
        }).catch(ref => { })

        return false
      }
      if (this.classid == -1) {
        return false
      }
      this.axios.get('doubleElevenByCateBrand', { params: { store_id: this.$store.state.shopid, class_id: this.classid, brand_id: this.pids,class_name:this.$store.state.soncname } }).then(res => {
        // console.log(res)
        this.goods = res.data.data
      }).catch(ref => { })
      // this.$router.push({ name: 'productList', params: { id: 1 } })
    },
    open () {
        
//       if(
//         sessionStorage.getItem("lfj")==1
//       ){
//       this.$router.push({name:'yy'})
// return
//       }
      this.$router.push({name:'yz',query:{id:1}})
      // if (this.login == 0) {
      //   Toast('请先登录')
      //   this.$router.push('login')
      //   return
      // }
      // this.$router.push('vip')
    },
    
  }
}
</script>
<style lang="less" scoped>
.bars {
  padding-top: 1.6rem;
}
.but {
  padding: 0 0.2rem;
}
.top {
  position: relative;
  .title {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    height: 1rem;
    text-align: center;
    line-height: 1rem;
    background-color: rgba(256, 256, 256, 0.5);
    border-radius: 0.36rem 0.36rem 0 0;
    font-size: 0.4rem;
  }
}
.no {
  padding-top: 1rem;
  text-align: center;
}
.nav {
  background-color: #fff;
  position: fixed;
  top: 1rem;
  left: 0;
  width: 100%;
  height: 2.666667rem;
  overflow-x: scroll; /*添加横向滚动条*/
  overflow-y: hidden;
  white-space: nowrap; /*不换行*/
  .one {
    width: 29%;
    margin: 2%;
    display: inline-block; /*设为inline-block*/
    position: relative;
    .xian {
      // border: 1px solid rgb(180, 13, 13);
      height: 0.1rem;
      width: 100%;
      background-color: rgb(180, 13, 13);
      position: absolute;
      top: 2rem;
      left: 0;
      z-index: 9999;
    }
  }
  .one img {
    width: 100%;
    height: 3.2rem;
  }
}
.product {
  display: flex;
  .wai {
    overflow: hidden;
    height: 100%;
  }
  .side {
    position: fixed;
    height: 77%;
    overflow-y: auto;

    left: 0;
    .van-sidebar {
      width: 1.333333rem;
    }
    .van-sidebar-item {
      background-color: #482e0d;
      color: #fff;
    }
    .van-sidebar-item--select {
      background-color: #ee0a24;
    }
  }
  .content {
    flex: 1;
    padding-left: 0.43333rem;
    .title {
      text-align: center;
      font-size: 0.4rem;
      height: 1rem;
    }
    ul {
      li {
        float: left;
        width: 45%;
        // padding: 0.266667rem 0.01rem 0.1rem 0.533333rem;
        // padding-left: 0.1rem;
        // padding-right: 0.1rem;
        height: 5.3rem;
        margin-left: 0.1rem;
        margin: 0.2rem 0.15rem 0.5rem 0.2rem;
        .zu{
        position: relative;

        }
        .pb{
          position: absolute;
          img{
          width:1.5rem;
          height: 1.5rem;

          }
          top: 0.1rem;
          right: 0.5rem;
        }
        img {
          width: 3.9rem;
          height: 3.9rem;
        }
        .price {
          height: 0.9rem;
          color: #f00a0a;
          line-height: 0.9rem;
          font-size: 0.4rem;
          font-weight: 700;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          span {
            font-weight: normal;
            color: #fff;
            background-color: #b81e42;
            padding: 0.1rem 0.2rem;
            border-radius: 0.3rem;
          }
        }
        .name {
          color: #464545;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space:normal ;
          width: 80%;
          font-size: 0.4rem;
        }
        .shop{
          padding-top: 0.1rem;
          // color: rgb(239, 81, 81);
        }
      }
    }
  }
}
.mi {
  padding: 0.5rem;
  text-align: center;

  p {
    font-size: 0.5rem;
    margin: 0.5rem;
  }
  input {
    height: 1rem;
    width: 70%;
    border-radius: 5%;
    font-size: 0.4rem;
  }
  margin-bottom: 1rem;
}
</style>